module.exports = __webpack_public_path__ + "img/arr-scroll.b3a28441.svg";